import React from "react"
import DozorTeamWithPointSequence from "./DozorTeamWithPointSequence";
import {Stack} from "@mui/material";
import {EmptyState} from "../../../components/ui/blocks";

export default function DozorData({dozor, accessType, dozorState}) {
    const {teams, points, transitions, getTeamSequences} = dozorState;

    if (teams.length === 0) {
        return <EmptyState message="Нет команд в смене" />;
    }

    return (
        <Stack spacing={2}>
            {teams.map((team) => (
                <DozorTeamWithPointSequence
                    key={team.id}
                    accessType={accessType}
                    team={team}
                    sequenceList={getTeamSequences(team.id)}
                    pointSet={points}
                    transitionSet={transitions}
                    dozorState={dozorState}
                />
            ))}
        </Stack>
    );
}
